import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "pad10 with_white_bg",
  style: {"margin-top":"20px","height":"200px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "clear" }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "fs24 kakugo centered fw600",
      style: {"color":"#696969"}
    }, "確認")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text centered",
    style: {"padding":"20px","color":"#696969","width":"410px"}
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "fs14 fw600 kakugo centered" }, "先に調整カレンダーを作成する必要があります。"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_2 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_3 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "調整カレンダーを作成", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "GoAvailableScheduleModal",
    "content-class": "ofs modalContent shadowContent rad10 modalNarrow"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goAvailableSchedule && _ctx.goAvailableSchedule(...args)))
          }, _hoisted_5)
        ])
      ])
    ]),
    _: 1
  }))
}